import { useAuth0 } from '@auth0/auth0-react'

type Role = 'admin' | 'operator' | 'user'

export function useRoles(): Role[] {
  const { user } = useAuth0()
  if (!user) return []
  const roles = user['https://hub.tesset.com/roles']
  // Match the API's default (apps/api/src/middleware/auth.ts:189): an
  // authenticated user with an absent/non-array/empty roles claim is
  // treated as role `user` — e.g. Google social sign-in, whose
  // post-user-registration Action assigning `user` only fires for
  // Database/Passwordless signups.
  return Array.isArray(roles) && roles.length > 0 ? (roles as Role[]) : ['user']
}

export function useHasRole(...requiredRoles: Role[]): boolean {
  const roles = useRoles()
  return roles.some((role) => requiredRoles.includes(role))
}
